import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'space', 'IconSpace', [["path",{"d":"M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3","key":"svg-0"}]]);